<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Webhooks</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataWebhooks"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/pabx/configuracoes/webhooks/criar"
              target="_blank"
              @click="handleGoToNewWebhook"
            >
              Criar Webhook
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
          disable-sort
          @dblclick:row="atualizar"
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <div class="actions-line">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    <v-switch
                      @change="ativarDesativarWebhook(item._id, item.ativo)"
                      dense
                      v-model="item.ativo"
                      class="mr-2"
                    />
                  </div>
                </template>
                <span>Ativar/Desativar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    dark
                    color="bluePcm"
                    class="mr-2"
                    :href="`/pabx/configuracoes/webhooks/atualizar/${item._id}`"
                    target="_blank"
                    v-bind="attrs"
                    v-on="on"
                    @click="atualizarButton(item, $event)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Editar</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="deletar(item)" icon small dark color="darkRed" v-bind="attrs" v-on="on">
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>Remover</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mt-4 grey--text">
            <p>Total de Webhooks: {{ qtdWebhooks }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import webhooksStore from '../_store'
import webhookHttpService from '../_services/webhookHttpServices'

export default {
  name: 'WebHooksHome',
  components: { ListPagination },

  mixins: [pagesHomeMixins],

  data: () => ({
    dataWebhooks: [],
    headers: [
      {
        text: 'Descrição',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapGetters('webhooksHomeModulePABXStore', ['getWebhooks']),

    numberOfPages() {
      return Math.ceil(this.dataWebhooks.length / this.itemsPerPage)
    },
    qtdWebhooks() {
      return this.dataWebhooks.length
    },
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'webhooksHomeModulePABXStore', webhooksStore)

    await this.listarWebhooks()
    this.dataWebhooks = [...this.getWebhooks]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('webhooksHomeModulePABXStore', ['listarWebhooks']),

    async ativarDesativarWebhook(idWebhook, activeStatus) {
      try {
        await webhookHttpService.updateWebhookActiveStatus(idWebhook, activeStatus)
      } catch (e) {
        console.log(e)
      }
    },

    handleGoToNewWebhook(event) {
      event.preventDefault()

      if (event.metaKey || event.ctrlKey) {
        const goToNewWebhook = this.$router.resolve({ name: 'Webhooks/criar' })
        window.open(goToNewWebhook.href, '_blank')
      } else {
        this.$router.push({ name: 'Webhooks/criar' })
      }
    },

    atualizar(event, item) {
      event.preventDefault()

      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`webhooks/atualizar/${item.item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`webhooks/atualizar/${item.item._id}`)
      }
    },

    atualizarButton(item, event) {
      event.preventDefault()

      if (event.metaKey || event.ctrlKey) {
        const updatePath = this.$router.resolve(`webhooks/atualizar/${item._id}`)
        window.open(updatePath.href, '_blank')
      } else {
        this.$router.push(`webhooks/atualizar/${item._id}`)
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o webhook "${item.description}"?`)
      if (resultado) {
        try {
          await webhookHttpService.deleteWebhooks(item._id)
          this.dataWebhooks = this.dataWebhooks.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>

<style scoped>
.actions-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
